'use client';

import { useEffect } from 'react';

// config in tagmanager (trigger name: gtm loaded)
const GTM_LOADED_EVENT = 'gtm:loaded';

export const useGtmReady = (callback: () => void) => {
  useEffect(() => {
    if (window.dataLayer && window.google_tag_manager) {
      callback();
      return;
    }

    const handler = () => callback();
    window.addEventListener(GTM_LOADED_EVENT, handler, { once: true });
    return () => window.removeEventListener(GTM_LOADED_EVENT, handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
